import afterorder from '../views/afterorder'

export default {
  path: '/afterorder',
  component: afterorder,
  redirect: '/afterorder/Orderlist',
  name: 'afterorder',
  meta: {
    title: '售后管理'
  },
  children: [
    {
      path: '/afterorder/orderlist',
      component: () => import('../views/afterorder/Orderlist'),
      name: 'Orderlist',
      meta: {
        title: '售后列表'
      }
    }
    // {
    //   path: '/afterorder/afterordercgList',
    //   component: () => import('../views/afterorder/htcgList'),
    //   name: 'afterorderList',
    //   meta: {
    //     title: '合同列表'
    //   }
    // },
    // {
    //   path: '/afterorder/whafterorder',
    //   component: () => import('../views/afterorder/whafterorder'),
    //   name: 'whafterorder',
    //   meta: {
    //     title: '合同维护'
    //   }
    // },
    // {
    //   path: '/afterorder/whafterorderList',
    //   component: () => import('../views/afterorder/whafterorderList'),
    //   name: 'whafterorderList',
    //   meta: {
    //     title: '维护列表'
    //   }
    // }

  ]

}
